import { CheckCircleOutlined, CloseOutlined } from "@ant-design/icons";

function ContactSuccessModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 animate-fadeIn">
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 animate-slideUp">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close"
        >
          <CloseOutlined style={{ fontSize: '20px' }} />
        </button>

        <div className="flex flex-col items-center text-center gap-4">
          <div className="bg-green-50 rounded-full p-3">
            <CheckCircleOutlined style={{ fontSize: '48px', color: '#52c41a' }} />
          </div>

          <h3 className="font-Poppins text-2xl font-bold text-gray-900">
            Thank You!
          </h3>

          <p className="font-Poppins text-base text-gray-600 leading-relaxed">
            Thank you for contacting us. We have received your message and will respond back to you shortly.
          </p>

          <button
            onClick={onClose}
            className="mt-4 w-full bg-[#E61F26] hover:bg-[#c71920] text-white font-Poppins font-medium py-3 px-6 rounded-lg transition-colors duration-200"
          >
            Close
          </button>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideUp {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }

        .animate-slideUp {
          animation: slideUp 0.3s ease-out;
        }
      `}</style>
    </div>
  );
}

export default ContactSuccessModal;